import React from 'react';
import { useNavigate } from 'react-router-dom';

function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="container" style={{ maxWidth: '900px', padding: '40px 20px' }}>
      <button
        onClick={() => navigate('/')}
        style={{
          background: 'transparent',
          border: '2px solid #667eea',
          color: '#667eea',
          padding: '10px 20px',
          borderRadius: '6px',
          marginBottom: '30px',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        ← Back to Home
      </button>

      <div className="card">
        <h1 style={{ fontSize: '2.5rem', marginBottom: '10px' }}>Terms of Service</h1>
        <p style={{ color: '#666', marginBottom: '30px' }}>
          <strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>1. Agreement to Terms</h2>
            <p>
              By accessing and using ViRaffle ("Service," "we," "our," or "us"), you agree to be bound by these Terms of Service
              ("Terms"). If you do not agree to these Terms, you may not access or use the Service.
            </p>
            <p style={{ marginTop: '15px' }}>
              These Terms apply to all users of the Service, including visitors, registered users, and paying customers.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>2. Description of Service</h2>
            <p style={{ marginBottom: '15px' }}>
              ViRaffle is a raffle management platform integrated with GoHighLevel that enables users to:
            </p>
            <ul style={{ paddingLeft: '30px' }}>
              <li>Create and manage digital raffle campaigns</li>
              <li>Generate and track raffle tickets</li>
              <li>Automatically select winners using fair randomization</li>
              <li>Integrate with GoHighLevel contacts and workflows</li>
              <li>Process payments through Stripe or PayPal</li>
              <li>Send automated notifications and announcements</li>
              <li>Manage multi-winner raffles with prize tiers</li>
              <li>Implement viral growth strategies</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>3. Account Registration</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>3.1 GHL Marketplace Installation</h3>
            <p>
              To use ViRaffle, you must install the app through the GoHighLevel Marketplace. By installing, you authorize
              ViRaffle to access your GHL account data as specified in our OAuth permissions.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>3.2 Account Security</h3>
            <p style={{ marginBottom: '15px' }}>You are responsible for:</p>
            <ul style={{ paddingLeft: '30px' }}>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized access</li>
              <li>Ensuring your account information is accurate and up-to-date</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>3.3 Account Eligibility</h3>
            <p>
              You must be at least 18 years old and have the legal capacity to enter into binding contracts to use ViRaffle.
              By registering, you represent that you meet these requirements.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>4. Subscription Plans and Billing</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>4.1 Subscription Tiers</h3>
            <p style={{ marginBottom: '15px' }}>ViRaffle offers multiple subscription plans:</p>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li><strong>Free Plan:</strong> Limited features for testing purposes</li>
              <li><strong>Starter Plan:</strong> $29/month (or $290/year)</li>
              <li><strong>Professional Plan:</strong> $79/month (or $790/year)</li>
              <li><strong>Scale Plan:</strong> $149/month (or $1,490/year)</li>
              <li><strong>Agency Plan:</strong> $199/month (or $1,990/year)</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>4.2 Payment Processing</h3>
            <p>
              Payments are processed through Stripe or PayPal. By subscribing, you authorize us to charge your selected
              payment method on a recurring basis according to your billing cycle.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>4.3 Billing Cycle</h3>
            <p>
              Subscriptions automatically renew at the end of each billing period (monthly or annually) unless cancelled
              before the renewal date. You will be charged at the beginning of each period.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>4.4 Refund Policy</h3>
            <p>
              <strong>No refunds</strong> are provided for partial months or years. If you cancel your subscription, you
              retain access until the end of your current billing period. All fees are non-refundable except as required
              by applicable law.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>4.5 Price Changes</h3>
            <p>
              We reserve the right to modify subscription prices with 30 days' advance notice. Price changes apply to
              renewals after the notice period. Existing subscribers will be grandfathered at their current rate for
              the remainder of their subscription period.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>4.6 Cancellation</h3>
            <p>
              You may cancel your subscription at any time through your account settings or by contacting support.
              Cancellation takes effect at the end of your current billing period.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>5. Acceptable Use Policy</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>5.1 Prohibited Activities</h3>
            <p style={{ marginBottom: '15px' }}>You agree NOT to:</p>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li>Conduct illegal raffles or lotteries in jurisdictions where prohibited</li>
              <li>Violate any local, state, federal, or international laws</li>
              <li>Engage in fraudulent activities or misrepresent raffle terms</li>
              <li>Manipulate winner selection or tamper with randomization</li>
              <li>Use the Service for spam or unsolicited communications</li>
              <li>Reverse engineer, decompile, or hack the Service</li>
              <li>Resell or redistribute access to the Service</li>
              <li>Use automated bots or scripts to abuse the Service</li>
              <li>Infringe on intellectual property rights</li>
              <li>Upload malicious code, viruses, or malware</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>5.2 Legal Compliance</h3>
            <p>
              You are solely responsible for ensuring your raffles comply with applicable laws in your jurisdiction,
              including but not limited to gambling laws, prize promotion laws, and consumer protection regulations.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>5.3 Content Standards</h3>
            <p style={{ marginBottom: '15px' }}>Raffle content must not contain:</p>
            <ul style={{ paddingLeft: '30px' }}>
              <li>Illegal, harmful, or offensive material</li>
              <li>False or misleading information</li>
              <li>Hate speech, harassment, or discrimination</li>
              <li>Adult or explicit content</li>
              <li>Violations of third-party rights</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>6. Raffle Operator Responsibilities</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>6.1 Your Obligations</h3>
            <p style={{ marginBottom: '15px' }}>As a raffle operator, you must:</p>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li>Clearly state raffle rules, terms, and eligibility requirements</li>
              <li>Honor all prizes and commitments made to participants</li>
              <li>Conduct fair and transparent winner selection</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Obtain necessary permits or licenses if required</li>
              <li>Provide accurate information about prizes</li>
              <li>Deliver prizes in a timely manner</li>
              <li>Handle participant data responsibly</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>6.2 Liability</h3>
            <p>
              You are solely responsible for your raffles, including prize fulfillment, tax reporting, legal compliance,
              and any disputes with participants. ViRaffle is a technology platform and does not operate, manage, or
              assume liability for your raffles.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>7. Intellectual Property</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>7.1 Our Rights</h3>
            <p>
              ViRaffle and its original content, features, and functionality are owned by us and are protected by
              copyright, trademark, and other intellectual property laws.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>7.2 Your Content</h3>
            <p>
              You retain ownership of raffle content you create. By using the Service, you grant us a limited license
              to use, store, and display your content solely to provide the Service.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>7.3 Trademarks</h3>
            <p>
              "ViRaffle" and associated logos are trademarks. You may not use our trademarks without prior written
              permission.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>8. Disclaimer of Warranties</h2>
            <p style={{ marginBottom: '15px' }}>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
              INCLUDING BUT NOT LIMITED TO:
            </p>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li>Warranties of merchantability or fitness for a particular purpose</li>
              <li>Warranties that the Service will be uninterrupted or error-free</li>
              <li>Warranties regarding accuracy, reliability, or completeness</li>
              <li>Warranties that defects will be corrected</li>
            </ul>
            <p>
              We do not warrant that winner selection is truly random or that the Service will meet your specific requirements.
              Use of the Service is at your own risk.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>9. Limitation of Liability</h2>
            <p style={{ marginBottom: '15px' }}>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, VIRAFFLE SHALL NOT BE LIABLE FOR:
            </p>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li>Indirect, incidental, special, consequential, or punitive damages</li>
              <li>Loss of profits, revenue, data, or business opportunities</li>
              <li>Damages resulting from unauthorized access to your account</li>
              <li>Damages caused by third-party integrations (e.g., GoHighLevel, Stripe, PayPal)</li>
              <li>Disputes between you and raffle participants</li>
              <li>Legal violations related to your raffles</li>
            </ul>
            <p>
              Our total liability for any claims shall not exceed the amount you paid us in the 12 months preceding
              the claim.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>10. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless ViRaffle, its officers, directors, employees, and agents
              from any claims, damages, losses, liabilities, and expenses (including attorney fees) arising from:
            </p>
            <ul style={{ paddingLeft: '30px', marginTop: '15px' }}>
              <li>Your use of the Service</li>
              <li>Your violation of these Terms</li>
              <li>Your raffles and prize fulfillment</li>
              <li>Your violation of any laws or third-party rights</li>
              <li>Disputes with raffle participants</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>11. Termination</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>11.1 By You</h3>
            <p>
              You may terminate your account at any time by cancelling your subscription and uninstalling the app from
              your GHL account.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>11.2 By Us</h3>
            <p style={{ marginBottom: '15px' }}>We may suspend or terminate your account if:</p>
            <ul style={{ paddingLeft: '30px', marginBottom: '20px' }}>
              <li>You violate these Terms</li>
              <li>Your payment fails or account is past due</li>
              <li>We reasonably believe you're engaged in fraudulent activity</li>
              <li>Required by law or legal process</li>
              <li>We discontinue the Service (with 30 days' notice)</li>
            </ul>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>11.3 Effect of Termination</h3>
            <p>
              Upon termination, your access to the Service ends immediately. We may delete your account data after
              30 days unless legally required to retain it.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>12. Dispute Resolution</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>12.1 Informal Resolution</h3>
            <p>
              Before filing a claim, you agree to contact us at <a href="mailto:support@aiandautomationmarketing.com" style={{ color: '#667eea' }}>support@aiandautomationmarketing.com</a> and
              attempt to resolve the dispute informally for at least 30 days.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>12.2 Arbitration</h3>
            <p>
              Any disputes that cannot be resolved informally shall be resolved through binding arbitration in accordance
              with the rules of the American Arbitration Association. You waive your right to a jury trial.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>12.3 Class Action Waiver</h3>
            <p>
              You agree that disputes must be brought on an individual basis only, and not as part of any class or
              representative action.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>13. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of [Your State/Country],
              without regard to its conflict of law provisions.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>14. Changes to Terms</h2>
            <p>
              We may update these Terms at any time. Material changes will be notified via email or prominent notice
              in the Service at least 30 days before taking effect. Continued use after changes constitutes acceptance
              of the new Terms.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>15. General Provisions</h2>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>15.1 Entire Agreement</h3>
            <p>
              These Terms constitute the entire agreement between you and ViRaffle regarding use of the Service.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>15.2 Severability</h3>
            <p>
              If any provision is found unenforceable, the remaining provisions remain in full effect.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>15.3 Waiver</h3>
            <p>
              Our failure to enforce any right or provision does not constitute a waiver of that right or provision.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>15.4 Assignment</h3>
            <p>
              You may not assign or transfer these Terms without our written consent. We may assign our rights and
              obligations without restriction.
            </p>

            <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', marginTop: '20px' }}>15.5 Force Majeure</h3>
            <p>
              We are not liable for delays or failures due to causes beyond our reasonable control.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#667eea' }}>16. Contact Information</h2>
            <p style={{ marginBottom: '15px' }}>
              For questions about these Terms, please contact:
            </p>
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
              <p style={{ margin: '5px 0' }}><strong>Email:</strong> <a href="mailto:legal@aiandautomationmarketing.com" style={{ color: '#667eea' }}>legal@aiandautomationmarketing.com</a></p>
              <p style={{ margin: '5px 0' }}><strong>Support:</strong> <a href="mailto:support@aiandautomationmarketing.com" style={{ color: '#667eea' }}>support@aiandautomationmarketing.com</a></p>
              <p style={{ margin: '5px 0' }}><strong>Website:</strong> <a href="https://viraffle.aiandautomationmarketing.com" style={{ color: '#667eea' }}>viraffle.aiandautomationmarketing.com</a></p>
            </div>
          </section>

          <div style={{
            marginTop: '50px',
            paddingTop: '30px',
            borderTop: '2px solid #e0e0e0',
            textAlign: 'center',
            color: '#666'
          }}>
            <p style={{ fontSize: '0.9rem' }}>
              © {new Date().getFullYear()} ViRaffle. All rights reserved.
            </p>
            <p style={{ fontSize: '0.85rem', marginTop: '10px' }}>
              <a href="/privacy" style={{ color: '#667eea', marginRight: '20px' }}>Privacy Policy</a>
              <a href="/support" style={{ color: '#667eea' }}>Support</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
